import React from 'react';
import styled from 'styled-components';
import useSnackbar from '../../hooks/useSnackbar';
import SnackBar from './SnackBar';

const SnackBarContainer = ({ action, deviceType, withAlertIcon, withoutIcon = false }) => {
  const { list, onClose } = useSnackbar({ action });

  return (
    <SnackContainer deviceType={deviceType}>
      {list.map(listAction => {
        return (
          <SnackBar
            key={listAction.id}
            result={listAction.result}
            component={listAction.component}
            onClose={() => onClose(listAction.id)}
            keepOpen={listAction.keepOpen}
            dataLayerText={listAction.result === 'ERROR' ? listAction.action : null}
            section={listAction.section}
            deviceType={deviceType}
            withAlertIcon={withAlertIcon}
            withoutIcon={withoutIcon}
          />
        );
      })}
    </SnackContainer>
  );
};

const SnackContainer = styled.div`
  position: fixed;
  bottom: 15px;
  display: flex;
  align-items: center;
  flex-direction: column;
  z-index: 501;
  width: 100%;
  right: 0;
  > span {
    :last-of-type {
      margin-bottom: ${({ deviceType }) => (deviceType !== 'mobile' ? '12px' : '0')};
    }
  }
`;

export default SnackBarContainer;
